module.exports = __webpack_public_path__ + "static/media/TopBarRightImage.bc63f725.jpg";